
// This is a temporary generated file. Changes to this file will be overwritten eventually!
import React, { useEffect, useState } from "react"
import Link from "gatsby-link"
import Header from "../src/components/Header"
import Layout from "../src/components/Layout"
import SEO from "../src/components/SEO"
import { Breadcrumb } from 'gatsby-plugin-breadcrumb'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { decode } from 'he'
import LandingHero from "../src/landingLayouts/LandingHero"
import LandingIntroSection from "../src/landingLayouts/LandingIntroSection"
import LandingAccordionColours from "../src/landingLayouts/LandingAccordionColours"
import LandingFeaturedImage from "../src/landingLayouts/LandingFeaturedImage"
import LandingImageTextSection from "../src/landingLayouts/LandingImageTextSection"
import LandingSignposts from "../src/landingLayouts/LandingSignposts"
import LandingSignpostsCta from "../src/landingLayouts/LandingSignpostsCta"

// Sections
import PageIntro from '../src/layouts/PageIntro';
import SingleSideBySideRepeater from '../src/layouts/SingleSideBySideRepeater';
import InformationAccordionRepeater from '../src/layouts/InformationAccordionRepeater';
import ServiceCta from '../src/layouts/ServiceCta';
import PageBody from '../src/layouts/PageBody';
import AwardCats from '../src/layouts/AwardCats';
import Teams from '../src/layouts/Teams';
import LatestNewsInsights from '../src/layouts/LatestNewsInsights';

const Page = ({ pageContext,location  }) => {
  const {
    page: { title, content, landingPageDynamicContent, dynamicContent,pageId,heroImage,stickyCtaBanner,seo},
    breadcrumb: { crumbs},
  } = pageContext

  const layouts = (dynamicContent.layouts || []).filter(Boolean)

  const landingPageLayouts = (landingPageDynamicContent?.landingPageFlexibleContent || []).filter(Boolean)
  const hasStickyCta = Boolean(stickyCtaBanner?.stickyCtaText)
  const [removeTemp, setRemoveTemp] = useState(false)
  const isPartiallyActive = ({ isPartiallyCurrent, isCurrent }) => {
    return isPartiallyCurrent && isCurrent
      ? { className: 'breadcrumb__link breadcrumb__link__active' }
      : {}
  }

  useEffect(() => {
    setRemoveTemp(false)
  }, [hasStickyCta])

  useScrollPosition(({ currPos }) => {
    if (!hasStickyCta) {
      return
    }

    if (currPos.y > -1) {
      setRemoveTemp(false)
      return
    }

    if (currPos.y < -800) {
      setRemoveTemp(true)
    }
  }, [hasStickyCta])

  function formatName(pageId) {
    return 'wrapper page-' + pageId;
  }
  function breadCrumbClass(){
    if(layouts[0] && layouts[0].fieldGroupName=="page_Dynamiccontent_Layouts_HeroBanner"){
      return 'content ';
    }
    else{
      return 'content no-image-breadcrumb';
    }
  }

  const newCrumbs = crumbs.map(item => {
    //console.log(item)
    const container = {};
    container.crumbLabel = decode(item.crumbLabel.replace(/-/g, ' '));
    container.pathname = item.pathname;

    return container;
  })

  return (
    <>
    <Header siteTitle={title} />
    <SEO title={seo.title} description={seo.metaDesc}/>
    <main className={formatName(pageId)}>
    {stickyCtaBanner.stickyCtaText ? (
    <div className={removeTemp ? 'sticky-cta visible' : 'sticky-cta'}>
    <div className="sticky-cta_title">{stickyCtaBanner.stickyPageSection} </div>
    <div  className="sticky-cta_para"  dangerouslySetInnerHTML={{ __html: stickyCtaBanner.stickyCtaText }}/>
      <div className="sticky-cta_btn-cont">
        <a href={stickyCtaBanner.stickyCtaLink}>
        <div className="sticky-cta_btn">
        {stickyCtaBanner.stickyCtaButtonText} </div>
        </a>
      </div>
    </div>
  )
  : null}
    <section className={breadCrumbClass()}>
    {crumbs ? (
    <div className="breadcrumbs">
      <Breadcrumb
        crumbs={newCrumbs}
        crumbSeparator=" / "
        crumbLabel={decode(title)}
        getProps={isPartiallyActive}
      />
    </div>
    )
    : null}
    </section>
    <Layout>
      {landingPageLayouts.map((landingLayout, index) => {
        if (landingLayout.fieldGroupName === "page_Landingpagedynamiccontent_LandingPageFlexibleContent_LandingHero") {
          return <LandingHero  {...landingLayout} key={index} />
        } else if(landingLayout.fieldGroupName === "page_Landingpagedynamiccontent_LandingPageFlexibleContent_LandingIntroSection") {
          return <LandingIntroSection  {...landingLayout} key={index} />
        } else if(landingLayout.fieldGroupName === "page_Landingpagedynamiccontent_LandingPageFlexibleContent_LandingAccordionColours") {
          return <LandingAccordionColours {...landingLayout} key={index} />
        } else if(landingLayout.fieldGroupName === "page_Landingpagedynamiccontent_LandingPageFlexibleContent_LandingFeaturedImage") {
          return <LandingFeaturedImage {...landingLayout} key={index} />
        } else if(landingLayout.fieldGroupName === "page_Landingpagedynamiccontent_LandingPageFlexibleContent_LandingImageTextSection") {
          return <LandingImageTextSection {...landingLayout} key={index} />
        } else if(landingLayout.fieldGroupName === "page_Landingpagedynamiccontent_LandingPageFlexibleContent_LandingSignposts") {
          return <LandingSignposts {...landingLayout} key={index} />
        } else if(landingLayout.fieldGroupName === "page_Landingpagedynamiccontent_LandingPageFlexibleContent_LandingSignpostsCta") {
          return <LandingSignpostsCta {...landingLayout} key={index} />
        }
      })}
      {
        layouts.map((layout, index) => {
          
              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_PageIntro') {
                  return <PageIntro {...layout} pageId={pageId} key={index} />;
              }
            

              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_SingleSideBySideRepeater') {
                  return <SingleSideBySideRepeater {...layout} pageId={pageId} key={index} />;
              }
            

              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_InformationAccordionRepeater') {
                  return <InformationAccordionRepeater {...layout} pageId={pageId} key={index} />;
              }
            

              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_ServiceCta') {
                  return <ServiceCta {...layout} pageId={pageId} key={index} />;
              }
            

              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_PageBody') {
                  return <PageBody {...layout} pageId={pageId} key={index} />;
              }
            

              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_AwardCats') {
                  return <AwardCats {...layout} pageId={pageId} key={index} />;
              }
            

              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_Teams') {
                  return <Teams {...layout} pageId={pageId} key={index} />;
              }
            

              if (layout.fieldGroupName === 'page_Dynamiccontent_Layouts_LatestNewsInsights') {
                  return <LatestNewsInsights {...layout} pageId={pageId} key={index} />;
              }
            
        })
      }
    </Layout>
    </main>
    </>
  )
}

export default Page
  